










































import { SettingsVueGB } from "@/extensions/settings/SettingsVueGB";
import { Component } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";
import PasswordEditModal from "@/components/settings/PasswordEditModal.vue";
// import AuthWithoutPassModal from "@/components/settings/AuthWithoutPassModal.vue";
import ShortCodeSetModal from "@/components/settings/ShortCodeSetModal.vue";
// AuthWithoutPassModal
@Component({
  components: {  
    BackLink,
    PasswordEditModal,
    ShortCodeSetModal
  }
})
export default class LoginSettingsModal extends SettingsVueGB {
  mounted() {
    this.shortCodeOn = window.localStorage.getItem('loginWithoutPasswordOn') === "1";
  }

  updated(): void {
    this.shortCodeOn = window.localStorage.getItem('loginWithoutPasswordOn') === "1";
  }

}
